import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ImageBanner.css';

// Component
import ImageBannerForm from '../../../components/siteadmin/ImageBannerForm';
import Loader from '../../../components/Loader';
import { withQuery } from '../../../hoc/withGraphql';

class ImageBanner extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getImageBanner: PropTypes.object,
    })
  };

  static defaultProps = {
    data: {
      loading: true,
      image: null
    }
  };


  render() {
    const { data: { loading, getImageBanner } } = this.props;
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      return <ImageBannerForm initialValues={getImageBanner} image={getImageBanner.image} />
    }
  }

}

export default compose(
  withStyles(s),
  withQuery(gql`
        {
            getImageBanner {
                id
                title
                description
                buttonLabel
                image
            }
        }
      `, {
    options: { ssr: false }
  }),
)(ImageBanner);
